import React from 'react';
import MyTasksCommon from '../_myTasksCommon';

export default props => (
  <MyTasksCommon
    {...props}
    staticQueryParams={{
      status: 1
    }}
  />
);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/MyTasks/MyActiveTasksList/MyActiveTasksList.js